import { render, staticRenderFns } from "./unit-info.vue?vue&type=template&id=649f9356&scoped=true"
import script from "./unit-info.vue?vue&type=script&lang=js"
export * from "./unit-info.vue?vue&type=script&lang=js"
import style0 from "./unit-info.vue?vue&type=style&index=0&id=649f9356&prod&lang=scss"
import style1 from "./unit-info.vue?vue&type=style&index=1&id=649f9356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649f9356",
  null
  
)

export default component.exports